import type { EntradaOutbox } from '../db/tipos'

export type EstadoDoPedido = 'sincronizado' | 'aguardando' | 'travado'

// Um pedido NAO e uma linha so: tem o cabecalho (`pedidos`), uma parte por marca
// (`sub_pedidos`) e os itens (`itens_pedido`). Se o selo olhasse so o cabecalho,
// ele diria "sincronizado" com os itens ainda presos no aparelho -- e essa e a
// mentira cara, a que faz ela fechar o app achando que pode trocar de celular.
function pertenceAoPedido(
  entrada: EntradaOutbox,
  pedidoId: string,
  subPedidoIds: readonly string[],
): boolean {
  const registro = entrada.registro
  if (entrada.tabela === 'pedidos') return registro.id === pedidoId
  if (entrada.tabela === 'sub_pedidos') return registro.pedido_id === pedidoId
  if (entrada.tabela === 'itens_pedido') {
    return subPedidoIds.includes(registro.sub_pedido_id as string)
  }
  return false
}

// Exportada porque o botao "Tentar de novo" precisa das LINHAS, nao do estado:
// e nelas que estao os ids a destravar.
export function entradasDoPedido(
  entradas: readonly EntradaOutbox[],
  pedidoId: string,
  subPedidoIds: readonly string[],
): EntradaOutbox[] {
  return entradas.filter((e) => pertenceAoPedido(e, pedidoId, subPedidoIds))
}

export function estadoDoPedidoNaFila(
  entradas: readonly EntradaOutbox[],
  pedidoId: string,
  subPedidoIds: readonly string[],
): EstadoDoPedido {
  const doPedido = entradasDoPedido(entradas, pedidoId, subPedidoIds)
  if (doPedido.length === 0) return 'sincronizado'
  // Travado ganha de qualquer outro estado, pela mesma razao que vale na barra:
  // ate 07/08 ela dizia "Sincronizado", em verde, com a fila cheia de recusado.
  if (doPedido.some((e) => e.travado_em)) return 'travado'
  return 'aguardando'
}
